import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

const HeaderSeparator: LitheFC = (): LitheElement<'div'> => ['div', {}, '|'];

export default HeaderSeparator;
